export const authoringGroundingLabels = {
  en: {
    useMaterials: 'Use linked material text as source context',
    summary: 'Draft created. Source quotes matched for {{supported}} of {{total}} questions. Review every question and answer before publishing.',
    truncated: 'Only part of the linked source text fitted the generation context.'
  },
  fr: {
    useMaterials: 'Utiliser le texte des documents liés comme contexte source',
    summary: 'Brouillon créé. Citations retrouvées pour {{supported}} question(s) sur {{total}}. Vérifiez chaque question et réponse avant publication.',
    truncated: 'Seule une partie du texte des sources liées a pu être utilisée pour la génération.'
  },
  hu: {
    useMaterials: 'Kapcsolt tananyagok szövegének használata forrásként',
    summary: 'Piszkozat létrehozva. {{total}} kérdésből {{supported}} esetén találtunk egyező forrásidézetet. Közzététel előtt ellenőrizzen minden kérdést és választ.',
    truncated: 'A generálás csak a kapcsolt forrásszöveg egy részét tudta felhasználni.'
  },
  ru: {
    useMaterials: 'Использовать текст связанных материалов как контекст источника',
    summary: 'Черновик создан. Цитаты подтверждены для {{supported}} из {{total}} вопросов. Перед публикацией проверьте каждый вопрос и ответ.',
    truncated: 'Для генерации использована только часть текста связанных источников.'
  },
  de: {
    useMaterials: 'Text verknüpfter Materialien als Quellenkontext verwenden',
    summary: 'Entwurf erstellt. Quellenzitate für {{supported}} von {{total}} Fragen gefunden. Prüfen Sie vor der Veröffentlichung jede Frage und Antwort.',
    truncated: 'Für die Generierung konnte nur ein Teil des verknüpften Quelltextes verwendet werden.'
  }
} as const;
